var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"width":"100%","height":"100%","src":_vm.videoUrl,"frameborder":"0","allow":"accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }